(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const animateOpen = (item, panel) => {
    item.open = true;
    if (reduceMotion) {
      panel.style.height = 'auto';
      return;
    }
    panel.style.height = '0px';
    panel.offsetHeight;
    panel.style.height = `${panel.scrollHeight}px`;
    const onEnd = (event) => {
      if (event.propertyName !== 'height') return;
      panel.style.height = 'auto';
      panel.removeEventListener('transitionend', onEnd);
    };
    panel.addEventListener('transitionend', onEnd);
  };

  const animateClose = (item, panel) => {
    if (reduceMotion) {
      item.open = false;
      panel.style.height = '0px';
      return;
    }
    panel.style.height = `${panel.scrollHeight}px`;
    panel.offsetHeight;
    panel.style.height = '0px';
    const onEnd = (event) => {
      if (event.propertyName !== 'height') return;
      item.open = false;
      panel.removeEventListener('transitionend', onEnd);
    };
    panel.addEventListener('transitionend', onEnd);
  };

  const initAccordion = (root) => {
    if (!root || root.dataset.almAccordionReady === 'true') return;
    root.dataset.almAccordionReady = 'true';

    root.querySelectorAll('.alm-pdp-accordion__item').forEach((item) => {
      const summary = item.querySelector('summary');
      const panel = item.querySelector('.alm-pdp-accordion__panel');
      if (!summary || !panel) return;

      panel.style.height = item.open ? 'auto' : '0px';

      summary.addEventListener('click', (event) => {
        event.preventDefault();
        if (item.open) {
          animateClose(item, panel);
        } else {
          animateOpen(item, panel);
        }
      });
    });
  };

  const boot = () => {
    document.querySelectorAll('[data-alm-accordion]').forEach(initAccordion);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
